function Betting(){
    return(
        <div>betting</div>
    )
}

export default Betting;